<template>
	<div class="task-calendar-item-container py-2">
		<v-row class="ma-0 px-3" justify="space-between">
			<div>
				<CalendarIcon :color="color" width="24" height="24" />
			</div>
			<CalendarItemMenu
				@click.stop
				:type="event_events"
				:color="'rgba(25, 42, 62, 0.5)'"
				:privileges="privileges"
				:isIncludingJob="eventObject.job !== null"
				:isInviteMultiple="eventObject.event_type.can_invitemultiple"
				:isCreatByOther="isCreatByOther"
				@click-menu-item="$emit('click-menu-item', $event)"
				@delete="$emit('delete')"/>
		</v-row>
		<v-row class="ma-0">
			<v-col cols="12" class="py-0">
				<div class="item-title-text">{{ eventObject.description }}</div>
			</v-col>
		</v-row>
		<v-row v-if="eventObject.all_day" class="ma-0 px-3" justify="space-between">
			<div class="item-time-text">
				<span>{{ formatDate(eventObject.start_date) }}&nbsp;&nbsp;</span>
				<span>All Day-event</span>
			</div>
		</v-row>
		<v-row v-if="!eventObject.all_day" class="ma-0">
			<v-col cols="12" class="py-0">
				<div class="item-time-text">
					<span>{{ formatDate(eventObject.start_date) }}&nbsp;&nbsp;</span>
					<span>{{ formatTime(eventObject.start_date, eventObject.end_date) }}</span>
				</div>
			</v-col>
		</v-row>
		<v-row v-if="reference.length !== 0" class="mx-3 my-2">
			<RecurringIcon class="mr-2" :color="'rgba(25, 42, 62, 0.5)'" width="16" height="16"/>
			<div class="item-time-text"> {{ reference }}</div>
		</v-row>
		<v-row class="ml-2 mr-1 my-2">
			<div class="task-calendar-item-row" style="justify-content: flex-start">
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
						<div v-bind="attrs" v-on="on">
							<v-user-avatar
								size="24"
								class="text-caption text-decoration-none mx-1"
								:code="formatName(organiser.display_name)"
								:image="`/api/addressbook/${organiser.id}/image.png`"
							/>
						</div>
					</template>
					<div class="task-calendar-item-text task-calendar-item-main ">{{ formatName(organiser.display_name) }}</div>
				</v-tooltip>
				<div class="item-time-text">Organiser</div>
			</div>
			<template v-if="invitees.length !== 0">
				<div v-for="invite of invitees" :key="invite.id">
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<div v-bind="attrs" v-on="on">
								<v-user-avatar
									size="24"
									class="text-caption text-decoration-none mx-1"
									:code="formatName(invite.employee ? invite.employee.display_name : invite.contact.display_name)"
									:image="`/api/addressbook/${invite.employee ? invite.employee.id : invite.contact.id}/image.png`"
								/>
							</div>
						</template>
						<span class="task-calendar-item-text task-calendar-item-main ">{{ formatName(invite.employee ? invite.employee.display_name : invite.contact.display_name) }}</span>
					</v-tooltip>
				</div>
			</template>
		</v-row>
	</div>
</template>
<script>
import CalendarIcon from "@/components/icons/calendar.vue";
import RecurringIcon from "@/components/icons/recurring.vue";

import CalendarItemMenu from "@/views/timesheets/calendar_item_menu.vue";

import moment from 'moment';

/* If selected, user will only be allow to amend items their own timesheets */
const TS = 'TS';

/* If selected, the user is allowed to delete timesheet entries */
const TsD = 'TsD';

const Event_Events = 'events';


/** etrepeatunit => 0 - no repeat, 1 - day, 2 - Weekday, 3 - Monthly, 4 - Yearly, 5 - Weekly */
const Etrepeat_Unit = ['no repeat', 'days', 'Weekdays', 'Months', 'Years', 'Weeks'];

const Weekday = 2;

const Repeat_Unit = [
	{
		text: 'Doesn’t repeat', 
		value: 0
	},
	{
		text: 'Daily', 
		value: 1
	},
	{
		text: 'Weekly', 
		value: 5
	},
	{
		text: 'Monthly', 
		value: 3
	},
	{
		text: 'Yearly', 
		value: 4
	},
	{
		text: 'Custom recurrence...', 
		value: 6
	}
];

export default {
	name: 'CalendarEventItem',
	props: {
		eventObject: {
			type: Object,
			default: () => {}
		},
		privileges: {
			type: Array,
			default: () => []
		},
		color: {
			type: String,
			default: ''
		},
		isCreatByOther: {
			type: Boolean,
			defaul: false
		}
	},
	components: {
		CalendarItemMenu,
		CalendarIcon,
		RecurringIcon
	},
	data() {
		this.event_events = Event_Events;
		this.Ts = TS;
		this.TsD = TsD;
		return {}
	},
	computed: {
		reference() {
			let reference_str = '';
			if (this.eventObject && this.eventObject.repeat_unit !== 0) {
				if (this.eventObject.repeat_value === 1) {
					let repeat_unit_select = null;
					if (this.eventObject.repeat_unit === Weekday) {
						repeat_unit_select = Repeat_Unit[Repeat_Unit.length - 1];
					} else {
						const repeat_unit_from_type = (Repeat_Unit.filter(u => { return u.value === this.eventObject.repeat_unit }))[0];
						repeat_unit_select = this.eventObject.repeat_value === 1 ? repeat_unit_from_type : Repeat_Unit[Repeat_Unit.length - 1];
					}

					reference_str = repeat_unit_select.text;

				} else {
					const unit = Etrepeat_Unit[this.eventObject.repeat_unit];
					const value_str = this.eventObject.repeat_unit !== 2 ? `${this.eventObject.repeat_value}` : '';
					reference_str = `${value_str} ${unit}`;
				}
			}
			return reference_str;
		},
		organiser() {
			return this.eventObject.organiser;
		},
		invitees() {
			let invitee_arr = [];
			if (this.eventObject && this.eventObject.invitees.length !== 0) {
				invitee_arr = this.eventObject.invitees.filter(invite => {
					const id = invite.employee ? invite.employee.id : invite.contact.id;
					return id !== this.eventObject.organiser.id;
				});
			}
			return invitee_arr;
		}
	},
	methods: {
		formatWeek(date_str) {
			return moment(date_str).format('ddd');
		},
		formatDate(date_str) {
			return moment(date_str).format('DD MMM');
		},
		formatTime(start_str, end_str) {
			return `${moment(start_str).format('hh:mm a')} - ${moment(end_str).format('hh:mm a')}`;
		},
		formatDuration(start_str, end_str) {
			const start = moment(start_str, 'YYYYMMDD HH:mm:ss');
			const end =  moment(end_str, 'YYYYMMDD HH:mm:ss');
			const diff = end.diff(start, 'minutes');

			const hours = Math.floor(diff / 60);
			const minutes = diff - (hours * 60);
			return `${hours}h ${minutes}m`;
		},
		formatName(name) {
			let display_name = '';

			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		}
	}
}
</script>
<style lang="scss" scoped>
.task-calendar-item-container {
  width: 100%;
	height: 100%;
  background: #FFFFFF;
  border: 1px solid rgba(25, 42, 62, 0.3);
  box-shadow: 0px 2px 4px rgba(25, 42, 62, 0.12);
  border-radius: 4px;
}
.item-title-text {
	font-family: Roboto;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	letter-spacing: 0.25px;
	color: #609800
}
.item-time-text {
	font-family: Roboto;
	font-size: 12px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.4px;
	color: #192A3EB2;
}
.task-calendar-item-row {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
}
.task-calendar-item-column {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: flex-start;
}
.task-calendar-item-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #192A3E;
}
.task-calendar-item-text {
  font-family: 'Roboto';
  font-style: normal;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.4px;
}
.task-calendar-item-main {
  font-weight: 500;
}
.task-calendar-item-sub {
  font-weight: 400;
}
.task-calendar-item-color-main {
  color: #192A3E;
}
.task-calendar-item-color-sub {
  color: rgba(25, 42, 62, 0.5);
}
</style>